export default func => {

	func();
	window.addEventListener('resize', func);

}
